import { render } from "./RuntimeEditor.vue?vue&type=template&id=18c5ff1c"
import script from "./RuntimeEditor.vue?vue&type=script&lang=js"
export * from "./RuntimeEditor.vue?vue&type=script&lang=js"
script.render = render

export default script